<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="m-icone direita">
          <div class="pesquisa">
            <input v-model="filtro" type="text" placeholder="Pesquisar por nome ou empresa" @input="pesquisar" />
            <a href="#" class="icone-pesquisa" title="Pesquisar" @click.prevent="dispararPesquisaIcone"></a>
          </div>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem">
          <div class="m-icone esquerda"><a @click="this.$router.back()" style="cursor: pointer"
              class="icone-voltar m-d"></a></div>
          <h2>Solicitações de Visitas</h2>
        </div>
      </div>
    </div>
    <div class="margem container">
      <div class="bloco margem bloco-lista-solicitacoes">
        <div class="tabela-solicitacoes-scroll">
          <table class="tabela alinha-centro tabela-solicitacoes">
            <thead>
              <tr>
                <th>Origem</th>
                <th>Anfitrião(ã)</th>
                <th>Visitante</th>
                <th>Empresa</th>
                <th>Data visita</th>
                <th>Status</th>
                <th>Fluxo digital</th>
                <th class="th-acoes">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in lista" :key="item.id || item._id">
                <td>
                  <span v-if="ehInformadaPeloAnfitriao(item)" class="badge-origem anfitriao"
                    title="Informada pelo anfitrião(ã) — complete a solicitação"> Anfitrião(ã) </span>
                  <span v-else class="badge-origem recepcao">Recepção</span>
                </td>
                <td>{{ item.nomeAnfitriao || "—" }}</td>
                <td>{{ textoVisitantes(item) }}</td>
                <td>{{ item.empresaOrigem || "—" }}</td>
                <td>{{ formatarPeriodoVisita(item) }}</td>
                <td>
                  <span class="chip" :class="classeStatus(item.statusAgendamento, item.cancelada)">{{
                    textoStatus(item.statusAgendamento, item.cancelada) }}</span>
                </td>
                <td class="col-fluxo">
                  <span v-if="curtaEtapaFluxoPendente(item)"
                    class="chip chip-fluxo-digital chip-fluxo-digital--pendente"
                    :title="'Fluxo digital — ' + rotuloFluxoDigital(item)">
                    <span class="chip-fluxo-pendente-label">Pendente</span>
                    <span class="chip-fluxo-pendente-etapa">{{ curtaEtapaFluxoPendente(item) }}</span>
                  </span>
                  <span v-else-if="rotuloFluxoDigital(item) === 'Fluxo concluído'"
                    class="chip chip-fluxo-digital chip-fluxo-digital--ok"
                    title="Todas as etapas do fluxo digital foram registradas">
                    <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                    <span>Concluído</span>
                  </span>
                  <span v-else class="cel-sem-fluxo">—</span>
                </td>
                <td class="col-acoes">
                  <div class="acoes-celula">
                    <template v-if="item.cancelada">
                      <router-link :to="'/solicitacao-visita/editar/' + (item.id || item._id)" class="link-acao"
                        title="Ver detalhes">Ver</router-link>
                    </template>
                    <template v-else-if="visitaSomenteLeituraPorData(item)">
                      <div class="acoes-links">
                        <router-link :to="'/solicitacao-visita/editar/' + (item.id || item._id)" class="link-acao"
                          title="Ver detalhes (data da visita já passou)">Ver</router-link>
                        <router-link v-if="!ehInformadaPeloAnfitriao(item)"
                          :to="'/acesso/checklist/' + (item.id || item._id)" class="link-acao" title="Check list">Check
                          list</router-link>
                      </div>
                    </template>
                    <template v-else-if="exibirBotaoCompletarSolicitacao(item)">
                      <router-link :to="'/solicitacao-visita/editar/' + (item.id || item._id)" class="btn-completar"
                        title="Completar solicitação com os dados do visitante">
                        <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
                        <span class="btn-completar-texto">Completar</span>
                      </router-link>
                    </template>
                    <template v-else>
                      <div class="acoes-links">
                        <router-link :to="'/solicitacao-visita/editar/' + (item.id || item._id)" class="link-acao"
                          title="Alterar solicitação">Alterar</router-link>
                        <span class="acoes-sep" aria-hidden="true">·</span>
                        <router-link :to="'/acesso/checklist/' + (item.id || item._id)" class="link-acao"
                          title="Abrir check list">Check list</router-link>
                        <span class="acoes-sep" aria-hidden="true">·</span>
                        <button type="button" class="link-acao btn-cancelar" title="Cancelar visita"
                          :disabled="cancelandoId === (item.id || item._id)" @click="confirmarCancelar(item)">
                          <i v-if="cancelandoId === (item.id || item._id)" class="fas fa-spinner fa-spin"></i> Cancelar
                        </button>
                      </div>
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="lista.length === 0 && !carregando">
              <tr>
                <td colspan="8" class="alinha-centro">Nenhuma solicitação encontrada.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="lastPage > 1" class="alinha-centro" style="margin-top: 1rem">
          <button @click="irPagina(page - 1)" :disabled="page <= 1">Anterior</button>
          <span style="margin: 0 1rem">Página {{ page }} de {{ lastPage }}</span>
          <button @click="irPagina(page + 1)" :disabled="page >= lastPage">Próxima</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { createToaster } from "@meforma/vue-toaster";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import { formatarPeriodoVisitaPtBr, isDataVisitaEstritamentePassada } from "@/utils/visita-data";

const toaster = createToaster({ position: "top-right" });

import { textoStatus as textoStatusConfig, classeStatus as classeStatusConfig } from "@/config/status-visita";
import {
  conviteFluxoDigitalConcluido,
  curtaEtapaFluxoDigitalPendente,
  exibeFluxoDigitalNaLista,
  isentaFluxoDigitalRecepcao,
  rotuloStatusFluxoDigitalLista,
} from "@/config/fluxo-digital-solicitacao";
export default {
  name: "ListaSolicitacoesView",

  data() {
    return {
      lista: [],
      page: 1,
      lastPage: 1,
      filtro: "",
      carregando: false,
      debounce: null,
      cancelandoId: null,
    };
  },

  created() {
    this.buscar();
  },

  methods: {
    ehInformadaPeloAnfitriao(item) {
      return item.origem === "anfitriao" || (item.nomeCompleto && !item.cpf && !item.rg && !item.empresaOrigem);
    },
    /** «Completar» some quando o fluxo digital existe e já foi todo concluído (ou dispensado). */
    exibirBotaoCompletarSolicitacao(item) {
      if (!this.ehInformadaPeloAnfitriao(item)) return false;
      if (isentaFluxoDigitalRecepcao(item)) return false;
      if (exibeFluxoDigitalNaLista(item) && conviteFluxoDigitalConcluido(item)) return false;
      return true;
    },
    visitaSomenteLeituraPorData(item) {
      return isDataVisitaEstritamentePassada(item?.dataVisita, item?.dataVisitaFim);
    },
    textoVisitantes(item) {
      const lista = item.listaVisitantes;
      if (Array.isArray(lista) && lista.length > 1) {
        const nomes = lista.map((v) => v.nomeCompleto).filter(Boolean);
        return nomes.length > 0 ? nomes.join(", ") : `Visita em grupo (${lista.length} pessoas)`;
      }
      return item.nomeCompleto || "—";
    },
    formatarPeriodoVisita(item) {
      const s = formatarPeriodoVisitaPtBr(item?.dataVisita, item?.dataVisitaFim);
      return s || "—";
    },
    formatarData(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      return d.toLocaleDateString("pt-BR");
    },

    textoStatus(s, cancelada) {
      return textoStatusConfig(s, cancelada);
    },

    classeStatus(s, cancelada) {
      return classeStatusConfig(s, cancelada);
    },

    rotuloFluxoDigital(item) {
      return rotuloStatusFluxoDigitalLista(item);
    },

    curtaEtapaFluxoPendente(item) {
      return curtaEtapaFluxoDigitalPendente(item);
    },

    confirmarCancelar(item) {
      if (this.visitaSomenteLeituraPorData(item)) {
        toaster.show("Não é possível cancelar uma visita cuja data já passou.", { type: "warning" });
        return;
      }
      const id = item.id || item._id;
      const nome = item.nomeCompleto || this.textoVisitantes(item);
      if (!window.confirm(`Cancelar a visita de "${nome}"? A visita ficará com status Cancelada.`)) return;
      this.cancelandoId = id;
      solicitacaoVisitaService
        .cancelar(id)
        .then(() => {
          toaster.show("Visita cancelada.", { type: "success" });
          this.buscar();
        })
        .catch((err) => {
          console.error(err);
          toaster.show("Erro ao cancelar visita.", { type: "error" });
        })
        .finally(() => {
          this.cancelandoId = null;
        });
    },

    pesquisar() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.page = 1;
        this.buscar();
      }, 400);
    },

    dispararPesquisaIcone() {
      clearTimeout(this.debounce);
      this.page = 1;
      this.buscar();
    },

    irPagina(p) {
      if (p < 1 || p > this.lastPage) return;
      this.page = p;
      this.buscar();
    },

    async buscar() {
      this.carregando = true;
      try {
        const res = await solicitacaoVisitaService.listar({
          page: this.page,
          search: this.filtro || undefined,
        });
        this.lista = res.data || [];
        this.lastPage = res.last_page ?? 1;
        this.page = res.current_page ?? 1;
      } catch (err) {
        console.error(err);
        this.lista = [];
        this.lastPage = 1;
        toaster.show("Erro ao carregar lista. Verifique se o backend expõe o endpoint solicitacao-visita.", {
          type: "error",
        });
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>
<style scoped>
.bloco-lista-solicitacoes {
  border-radius: 12px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-bg);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.tabela-solicitacoes-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 -0.25rem;
}

.tabela-solicitacoes {
  min-width: 920px;
  border-collapse: separate;
  border-spacing: 0;
}

.tabela-solicitacoes thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cor-fonte-fraca);
  font-weight: 700;
  padding: 0.65rem 0.5rem;
  border-bottom: 1px solid var(--cor-separador);
  background: transparent;
}

.tabela-solicitacoes tbody td {
  padding: 0.75rem 0.5rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--cor-separador);
  font-size: 0.92rem;
}

.tabela-solicitacoes tbody tr:last-child td {
  border-bottom: none;
}

.th-acoes {
  text-align: left !important;
  min-width: 10.5rem;
}

.col-fluxo {
  text-align: center;
  min-width: 7.5rem;
}

.linha-acoes-nova-visita {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem 0.75rem;
}

.status-pendente {
  background: var(--cor-cinza);
  color: var(--cor-fonte-fraca);
}

.status-processo {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
}

.status-confirmada {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
}

.status-em-visita {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
}

.status-concluido {
  background: var(--cor-primaria-fraca);
  color: var(--cor-sucesso);
}

.status-cancelada {
  background: var(--cor-cinza);
  color: var(--cor-erro);
}

.badge-origem {
  display: inline-block;
  padding: 0.25rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid transparent;
}

.badge-origem.anfitriao {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
  border-color: hsl(var(--h) var(--s) var(--l) / 0.18);
}

.badge-origem.recepcao {
  background: var(--cor-cinza2);
  color: var(--cor-fonte);
  border-color: var(--cor-separador);
}

.cel-sem-fluxo {
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
}

.chip-fluxo-digital {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 10.5rem;
  text-align: center;
  line-height: 1.2;
  font-size: 0.78rem;
  border-radius: 10px;
  border: 1px solid transparent;
  box-shadow: none;
}

/* Plano, alinhado aos chips de status / origem (evita gradiente claro no .dark) */
.chip-fluxo-digital--pendente {
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.45rem 0.6rem;
  background: var(--cor-primaria-fraca);
  border-color: var(--cor-primaria-media);
  color: var(--cor-fonte-forte);
}

.chip-fluxo-pendente-label {
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cor-fonte-fraca);
}

.chip-fluxo-pendente-etapa {
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.15;
  color: var(--cor-primaria-forte);
}

.chip-fluxo-digital--ok {
  gap: 0.35rem;
  padding: 0.35rem 0.6rem;
  background: var(--cor-primaria-fraca);
  color: var(--cor-sucesso);
  border-color: hsl(130 var(--s) calc(var(--l) + 6%) / 0.35);
  font-weight: 700;
}

.chip-fluxo-digital--ok i {
  font-size: 0.85rem;
}

.col-acoes {
  white-space: normal;
  max-width: 14rem;
  text-align: left;
  vertical-align: middle;
}

.acoes-celula {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.acoes-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.15rem 0.25rem;
  font-size: 0.88rem;
}

.acoes-sep {
  color: var(--cor-fonte-fraca);
  user-select: none;
  padding: 0 0.05rem;
}

.btn-completar {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.38rem 0.85rem;
  background: var(--cor-primaria);
  color: var(--cor-bg);
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.8125rem;
  font-weight: 700;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
}

.btn-completar:hover {
  background: var(--cor-primaria-forte);
  color: var(--cor-bg);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.btn-completar:active {
  transform: translateY(1px);
}

.btn-completar-texto {
  white-space: nowrap;
}

.link-acao {
  color: var(--cor-primaria-forte);
  text-decoration: none;
  font-weight: 600;
  border-radius: 4px;
  padding: 0.1rem 0.05rem;
}

.link-acao:hover {
  text-decoration: underline;
  color: var(--cor-primaria);
}

.btn-cancelar {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  color: var(--cor-erro);
}

.btn-cancelar:hover:not(:disabled) {
  text-decoration: underline;
}

.btn-cancelar:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
